import { LOGO_URL } from "../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative py-16 overflow-hidden"
      style={{
        zIndex: 50,
        background:
          "linear-gradient(180deg, transparent 0%, #ffd1dc 30%, #ffb3b3 100%)",
      }}
    >
      <div className="relative max-w-7xl mx-auto px-6 flex flex-col items-center text-center">
        <img src={LOGO_URL} alt="Amyu" className="h-16 mb-5 drop-shadow-[0_8px_20px_rgba(229,91,91,0.2)]" />
        <p className="font-hand text-3xl text-coral">à très vite ♡</p>
        <p className="mt-3 text-sm text-amyu-ink/80 max-w-md">
          Amyu — gourmandises faites maison, créées avec amour par un couple passionné.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
          <a href="#histoire" className="text-amyu-ink hover:text-coral transition-colors">Notre histoire</a>
          <a href="#gourmandises" className="text-amyu-ink hover:text-coral transition-colors">Gourmandises</a>
          <a href="#galerie" className="text-amyu-ink hover:text-coral transition-colors">Galerie</a>
          <a href="#contact" className="text-amyu-ink hover:text-coral transition-colors">Contact</a>
        </div>
        <div className="mt-10 text-xs text-amyu-ink/60">
          © {new Date().getFullYear()} Amyu — Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};
